import { t } from 'i18next';

export const getDefaultJobTitles = (): string[] => {
  return [
    t('jobTitles.forkliftOperator', { defaultValue: '' }),
    t('jobTitles.genericTransportDriver', { defaultValue: '' }),
    t('jobTitles.driverCatC', { defaultValue: '' }),
    t('jobTitles.earthmovingMachineryOperator', { defaultValue: '' }),
  ];
};
